
<template>
    <div class="mt-5 mb-5">
		<div>
			<div class="row">
	            <div class="col">
	                <strong>Keywords</strong>
	            </div>
	            <div class="col text-right mb-2">
	                <button class="btn btn-primary" data-toggle="modal" data-target="#addKeywords">Add Keywords</button>
	            </div>
	        </div>
	        <div class="table-responsive">
	            <table class="table tr-hover-none">
	                <thead>
	                    <tr>
	                        <th>Keywords</th>
	                        <th>Bid</th>
	                        <th>Type</th>
	                        <th>Action</th>
	                    </tr>
	                </thead>
	                <tbody>
	                    <template v-for="(item, k) in keywordList">
	                        <tr v-for="(bidItem, j) in item.bids" :key="JSON.stringify(bidItem) + j">
	                            <td :rowspan="item.bids && item.bids.length ? item.bids.length : 1" v-if="j==0"  style="padding-right:50px !important; width:65%">
									<ProductListChipView v-if="keywordTextAreaList[k]" :productList="keywordTextAreaList[k].keyword.split('\n')"></ProductListChipView>
									<!-- <div v-else>Error: {{k}}{{JSON.stringify(keywordTextAreaList)}}</div> -->
								</td>
	                            <!-- <textarea :rows="5" v-model="keywordTextAreaList[k].keyword" style="height:75px;width:75%;"></textarea> -->
	                            <td :key="bidItem.bid + j">{{ '$ ' + bidItem.bid }}</td>
	                            <td :key="bidItem.type + j">{{ bidItem.type }}</td>
	                            <td :key="JSON.stringify(bidItem) + j + 'td'" :rowspan="item.bids && item.bids.length ? item.bids.length : 1" v-if="j==0">
	                                <a href="javascript:void(0)" @click="editSelectedKeyword(k)" data-toggle="modal" data-target="#addKeywords">Edit</a>
	                                <a href="javascript:void(0)" @click="openDeleteKeywordModal(k)" style="padding-left:5px">Remove</a>
	                            </td>

	                        </tr>
	                        <tr class="border-top" :key="k" v-if="k != keywordList.length - 1"><td></td><td></td><td></td><td></td></tr>
	                    </template>
	                </tbody>
	            </table>
	        </div>
	        <p class="pt-5">Bid for each type of Targeting Type</p>
			<p v-if = "isAddKeyword" style = "color : red">Please define Keywords for the Manual Targeting Type</p>
	        <hr />
		</div>

        <div>
            <button class="btn btn-secondary" @click="navigateToProductList">Cancel</button>
            <button class="btn btn-primary" @click="saveNewCampaign()">Save</button>
        </div>
        <RemoveKeywordConfirmModal @removeKeyword="deleteSelectedKeyword"></RemoveKeywordConfirmModal>
    </div>
</template>

<script>
import ProductListChipView from '@/components/product/ProductListChipView'
import RemoveKeywordConfirmModal from '@/components/add-campaign/RemoveKeywordConfirmModal'



export default {
    name:'AddCampaignKeywordGrid',
    data() {
        return {
            keywordTextAreaList:[],
            selectedKeywordIndex: null,
			isAddKeyword : false
        }
    },
    props: {
        keywordList: {
            type: Array
        },
		campaignTargetType : String
    },
    components: {
        ProductListChipView,
        RemoveKeywordConfirmModal,
    },
	mounted(){
		this.updateKeywordTextAreaList()
	},
    watch: {
		campaignTargetType(){
			this.isAddKeyword  = false
		},
        keywordList() {
			this.isAddKeyword = false
            this.updateKeywordTextAreaList()
        }
    },
    methods: {
		updateKeywordTextAreaList(){
			if (this.keywordList) {
                this.keywordTextAreaList = []
                for(let i=0; i<this.keywordList.length; i++) {
					if(this.keywordList[i].keyword[this.keywordList[i].keyword.length -1] == ""){
						this.keywordList[i].keyword.splice(this.keywordList[i].keyword.length - 1, 1)
					}

			 		  this.keywordTextAreaList.push({keyword:this.keywordList[i].keyword.join('\n')})
                }
                console.log(this.keywordTextAreaList)
            }
		},
        navigateToProductList() {
            if (this.$route.params.groupId && parseInt(this.$route.params.groupId) > -1) {
                this.$router.push({path: '/campaignList/' + this.$route.params.groupId})
            } else if (this.$route.params.campaignId && parseInt(this.$route.params.campaignId) > -1) {
				this.$store.state.calledFromCancel = true;
                this.$router.push({path: '/campaignList'})
            } else if (this.$route.params.products && this.$route.params.products.length > 0) {
                this.$router.push({path: '/productList'})
			} else if(this.$route.fullPath=="/addEditCampaign") {
				this.$store.state.calledFromCancel = true;
				this.$router.push({path: '/campaignList'})
			}
			else{
				this.$router.push({path: '/campaignList'})
			}
        },
        // openSaveConfirmModal() {
        //     $('#confirmAddCampaign').modal('show')
        // },
        saveNewCampaign() {
            // $('#confirmAddCampaign').modal('hide')
		//	if(this.campaignTargetType!='auto'){
			//	if(this.keywordList.length){
					this.isAddKeyword = false
					this.$emit('saveCampaign')
			//	}
				// else{
				// 	this.isAddKeyword = true
				// }
			//}
			// else{
			// 	this.isAddKeyword = false
			// 	this.$emit('saveCampaign')
			// }

        },
        openDeleteKeywordModal(keywordIndex) {
            this.selectedKeywordIndex = keywordIndex
            $('#confirmRemoveKeyword').modal('show')
        },
        deleteSelectedKeyword(keywordIndex) {
            $('#confirmRemoveKeyword').modal('hide')
            this.$emit('deleteSelectedKeyword', this.selectedKeywordIndex)
        },
        editSelectedKeyword(keywordIndex) {
            // let editSelectedKeyword = item
            this.$emit('editSelectedKeyword', keywordIndex)
        }
    }
}
</script>

<style lang="scss">

</style>
